export const useActivityExternalApplyController = () => {
  const handleOpenExternalApplyLink = (externalApplyLink: string) => {
    window.open(externalApplyLink, '_blank');
  };

  return { handleOpenExternalApplyLink };
};
